import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { REVIEW_STEP } from 'constants/checkoutFlow';
import { evPlaceOrder } from 'events/checkout';

import { trackEvent } from 'helpers/analytics';
import { pushPlaceOrder } from 'actions/checkout/purchase';
import { track } from 'apis/amethyst';
import PlaceOrderButtonSection from 'components/checkout/caap/spc/PlaceOrderButtonSection';
import StepSection from 'components/checkout/caap/StepSection';
import { isReadyToSubmit } from 'helpers/CheckoutUtils';

export class OrderTotalSection extends Component {
  onPlaceOrderClicked = () => {
    const { checkoutData, pushPlaceOrder } = this.props;
    trackEvent('TE_CHECKOUT_SPC_PLACE_ORDER', 'bottom');
    track(evPlaceOrder, { ...checkoutData });
    pushPlaceOrder();
  }

  showChargeSummary = () => {
    const { shipOptions } = this.props.checkoutData;
    return this.showReviewStep() && !shipOptions.showModal;
  }

  showReviewStep = () => {
    const { purchaseData: { targetStep } } = this.props.checkoutData;
    return targetStep === REVIEW_STEP;
  }
  render() {
    const {
      purchaseData: {
        data: { chargeSummary = {} },
        isOrderBeingPlaced,
        isFetchingCheckoutData
      }
    } = this.props.checkoutData;
    const { testId } = this.context;

    const isOrderReadyToSubmit = !isFetchingCheckoutData && isReadyToSubmit(this.props.checkoutData);
    const { grandTotal } = chargeSummary;

    return (
      <StepSection isCurrentStep={this.showChargeSummary()} dataTestIdLoader={`${testId('spinner')}`}>
        <PlaceOrderButtonSection
          onPlaceOrderClicked={this.onPlaceOrderClicked}
          isOrderBeingPlaced={isOrderBeingPlaced}
          isReadyToSubmit={isOrderReadyToSubmit}
          orderTotal={chargeSummary && grandTotal}
        />
      </StepSection>
    );
  }
}

function mapStateToProps(state) {
  return {
    checkoutData: state.checkoutData
  };
}

OrderTotalSection.contextTypes = {
  testId: PropTypes.func
};

export default connect(mapStateToProps, {
  pushPlaceOrder
})(OrderTotalSection);
